import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, NavLink } from 'react-router-dom'; // Замени Switch на Routes
import MainScreen from './MainScreen';
import Statistics from './Statistics';
import './App.css';
import { IoHomeOutline } from "react-icons/io5";
import { IoStatsChartOutline } from "react-icons/io5";

function App() {
  const [filter, setFilter] = useState('Hamma');

  return (
    <Router>
      <div className="app">
        <Routes> {/* Замени Switch на Routes */}
          <Route path="/" element={<MainScreen filter={filter} setFilter={setFilter} />} />
          <Route path="/statistics" element={<Statistics />} />
        </Routes>
        <div className="tabbar" style={{ position: 'fixed', bottom: 0, left: 0, right: 0, display: 'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
          <NavLink to="/" className={ ({ isActive }) => ( isActive ? "tabbare active" : "tabbare")} > <IoHomeOutline />  Bosh sahifa</NavLink>
          <NavLink to="/statistics" className={ ({ isActive }) => ( isActive ? "tabbare active" : "tabbare")} > <IoStatsChartOutline /> Statistika</NavLink>
        </div>
      </div>
    </Router>
  );
}

export default App;